<template>
  <TableLayout :permissions="['business:hotcity:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>

      <el-form-item label="城市名称" prop="cityName">
        <el-input v-model="searchForm.cityName" placeholder="请输入城市名称" @keypress.enter.native="search"></el-input>
      </el-form-item>

      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar" v-permissions="['business:hotcity:create']">
        <li><el-button type="primary" @click="$refs.operaHotCityWindow.open('新建常用城市')" icon="el-icon-plus" v-permissions="['business:hotcity:create']">新建</el-button></li>
      </ul>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
        border
      >
        <el-table-column prop="cityName" label="城市名称" align="center" min-width="100px"></el-table-column>
        <el-table-column prop="sortnum" label="排序码（升序）" align="center" min-width="100px"></el-table-column>
        <el-table-column prop="createDate" label="创建时间" align="center" min-width="100px"></el-table-column>
        <el-table-column
          v-if="containPermissions(['business:hotcity:update', 'business:hotcity:delete'])"
          label="操作"
          align="center"
          min-width="120"
          fixed="right"
        >
          <template slot-scope="{row}">
            <el-button type="text"  style="color: red;" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['business:hotcity:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 新建/修改 -->
    <OperaHotCityWindow ref="operaHotCityWindow" @success="handlePageChange"/>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaHotCityWindow from '@/components/business/OperaHotCityWindow'
export default {
  name: 'HotCity',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaHotCityWindow },
  data () {
    return {
      // 搜索
      searchForm: {
        id: '',
        creator: '',
        createDate: '',
        editor: '',
        editDate: '',
        isdeleted: '',
        info: '',
        cityId: '',
        sortnum: ''
      }
    }
  },
  created () {
    this.config({
      module: '常用城市配置表',
      api: '/business/hotCity',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  }
}
</script>
